
import { mapGetters } from 'vuex'
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
import CryptoJS from '~/helpers/rezz-crypto.js'

export default {
  components: { InnerPageTitle },
  props: {
    fast: {
      default: false,
      type: Boolean,
    },
    autoLogin: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
      getAutoLogin: 'user/getAutoLogin',
      getSettings: 'getSettings',
    }),
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      alertBox: {
        status: false,
        message: '',
        variant: '',
      },
      loading: false,
    }
  },
  methods: {
    async SEND_TO_LOGIN(e) {
      e.preventDefault()
      if (this.loading) return
      this.loading = true
      this.alertBox = await this.$store.dispatch(
        'user/SEND_TO_LOGIN',
        this.form
      )
      if (this.alertBox.variant === 'success') {
        if (this.fast) return this.$emit('login:success')
        const redirectPath = this.$cookies.get('redirectPath') || this.$store.getters['getReturnUrl'] || '/'
        this.$cookies.remove('redirectPath')
        this.$router.push({
          path: this.localePath(redirectPath),
          query: { action: 'fast-buy' },
        })
      }
      this.loading = false
    },
    CHECK_AUTO_LOGIN() {
      if (!this.getAutoLogin.status) return
      this.form = {
        email: this.getAutoLogin.email,
        password: this.getAutoLogin.password,
      }
      this.$store.commit('user/REMOVE_AUTO_LOGIN')
      this.SEND_TO_LOGIN({ preventDefault: () => true })
    },
    AUTO_LOGIN() {
      if (!this.autoLogin) return
      const uniqueyHashKey = "company:" + this.getSettings.id;
      const Crypto = new CryptoJS(uniqueyHashKey);
      try {
        const query = this.$route.query;
        if (query.hash) {
          const decryptedHash = Crypto.decrypto(query.hash);
          const hashData = JSON.parse(decryptedHash);

          console.log(hashData);

          if (hashData.username && hashData.password) {
            this.form = {
              email: hashData.username,
              password: hashData.password,
            }
            this.SEND_TO_LOGIN({ preventDefault: () => true })
          }
        } else {
          throw new Error("Hash bulunamadı.");
        }
      } catch (error) {
        alert("Hash şifreleme hatası detay için console'a bakınız.");
        console.error(error);
        console.log("crypto-js kütüphanesini kurarak CJS.AES.encrypt(originalText, uniqueyHashKey).toString() fonksiyonu ile şifreleme yapınız. Bu konuda dafa fazla bilgi için Müşteri Temsilciniz ile iletişime geçiniz.");
        console.log("Hash şifreleme keyi: (uniqueyHashKey) -> ", uniqueyHashKey);
        if (error.message.includes("Unexpected end of JSON input")) {
          console.log("Hash JSON.Stringy olarak {username: 'test@test.com', password: '123456'} şeklinde olmalıdır. Hash şifreleme keyi ise size verilen hash keyi ile şifrelenmelidir. Bu konuda dafa fazla bilgi için Müşteri Temsilciniz ile iletişime geçiniz. ");
        }
      }
    },
  },
  mounted() {
    this.CHECK_AUTO_LOGIN()
    this.AUTO_LOGIN()
  },
}
